import React from 'react';
import styles from './Header.module.css';

export const Header: React.FC = () => {
  return (
    <header className={styles.header}>
      <div className={styles.container}>
        <h1 className={styles.title}>Online Chess</h1>
        <nav className={styles.nav}>
          <a href="/" className={styles.link}>Home</a>
        </nav>
      </div>
    </header>
  );
};